import React from "react"
import { Block } from "baseui/block"
import Slick from "./Slick/Slick"
import { Label2 } from "baseui/typography"

const Slider = ({ contents, landscape = true }: any) => {
  return (
    <Block paddingTop={"30px"} paddingBottom={"30px"}>
      <Slick>
        {contents &&
          contents.map((item: any) => (
            <Block height="auto">
              <Block
                onClick={() => {
                  window.open(item.link)
                }}
                className={"post-card"}
                width={landscape ? "350px" : "250px"}
                height={landscape ? "180px" : "350px"}
                position="relative"
                marginLeft="10px"
                marginRight="10px"
                overflow={"hidden"}
                overrides={{
                  Block: {
                    style: {
                      cursor: "pointer",
                      borderRadius: "4px",
                    },
                  },
                }}
              >
                <img
                  src={item.image}
                  style={{
                    transition: "transform .4s ease",
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                  }}
                />
                <Block
                  width="100%"
                  height="40%"
                  position="absolute"
                  bottom="0px"
                  $style={{
                    background:
                      "linear-gradient(rgba(0, 0, 0, 0), rgb(0, 0, 0))",
                  }}
                />
                <Block position="absolute" bottom="15px" left="15px">
                  <Label2 color="white">{item.title}</Label2>
                </Block>
              </Block>
            </Block>
          ))}
      </Slick>
    </Block>
  )
}

export default Slider
